import React from 'react';
import CheckmarkIcon from '../../../common/icons/check-mark2.svg';
import './index.scss';

const Checkbox = ({ id, isChecked, onChange, text, clickableText, disabled }) => {
    const onCheckboxChange = (isChecked) => {
        if (onChange && !disabled) {
            onChange(isChecked);
        }
    };
    const onTextClick = () => {
        if (onChange && !disabled) {
            onChange(isChecked ? false : true);
        }
    };

    return (
        <div id={id} className={'checkbox' + (isChecked ? ' checked' : '')}>
            <div className="checkbox--checkmark">
                <label>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        disabled={disabled ? 'disabled' : ''}
                        onChange={(e) => onCheckboxChange(e.target.checked)}
                    />
                    <span className="checkmark">
                        <CheckmarkIcon />
                    </span>
                </label>
            </div>
            <div className="checkbox--content">
                {clickableText ? (
                    <div className="clickableText" onClick={() => onTextClick()}>
                        {clickableText}
                    </div>
                ) : null}
                {text && <div className="text">{text}</div>}
            </div>
        </div>
    );
};

export default Checkbox;
